// Redux state for the global ContactLead popup singleton.
//
// Why this exists: ~9 React callsites already mount <ContactLeadPopupRouter />
// directly, but non-React launchers (e.g. commandRegistry.js actions) have no
// component to mount and would otherwise have to duplicate the V1/V2 swap
// inline. This slice + the matching <ContactLeadPopupSingleton /> mounted in
// the dashboard layout give any code path — React or not — a single dispatch
// to open the right popup version for the current practice.
//
// State shape:
//   open    — boolean, dialog visibility
//   leadId  — numeric lead id to load + display (null when closed)
//   opts    — extra options bag forwarded to the popup (e.g. currentTab,
//             headerButtons). Keep to serialisable values; non-serialisable
//             callbacks (handleReloadLeads) should be wired inside the
//             singleton, not pushed through Redux.
//
// NOTE: this slice does NOT migrate the existing 9 React callsites — those
// keep using <ContactLeadPopupRouter /> directly. It is purely additive
// infrastructure for non-React launchers.

import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'contactLeadPopup',
    initialState: { open: false, leadId: null, opts: {} },
    reducers: {
        openContactLeadPopup(state, action) {
            const { leadId = null, opts = {} } = action.payload || {};
            state.open = true;
            state.leadId = leadId;
            state.opts = opts;
        },
        closeContactLeadPopup(state) {
            state.open = false;
            state.leadId = null;
            state.opts = {};
        },
    },
});

export const { openContactLeadPopup, closeContactLeadPopup } = slice.actions;
export default slice.reducer;
